const dataLayer = []
function addToDataLayer (data) {
  window.dataLayer.push(data)
}
export { addToDataLayer, dataLayer }
